import { render, staticRenderFns } from "./Liberar.vue?vue&type=template&id=5222d476&"
import script from "./Liberar.vue?vue&type=script&lang=js&"
export * from "./Liberar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports